<template>
  <VLayout
    upline
    :title="$t('account_order_details.title')"
    :bgImage="false"
  >
    <TransactionDetail
      type="order"
      :transaction_uuid="$route.params.order_uuid"
    />
    <VButtonGroup />
  </VLayout>
</template>

<script>
import VLayout from "@/layouts/Default";
import TransactionDetail from "@/components/TransactionDetail";
import VButtonGroup from "@/components/VButtonGroup";

export default {
  components: {
    VLayout,
    TransactionDetail,
    VButtonGroup,
  },
  fallbackI18n: {
    messages: {
      und: {
        account_order_details: {
          title: "Order details",
        },
      },
    },
  },
  mounted: function() {},
  methods: {},
};
</script>
